var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTreatments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_230_4093)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.50266 35.2568L6.73894 33.561C4.85152 31.7463 4.79241 28.7346 6.60713 26.8472L15.3104 17.7953L23.9198 26.073L15.2165 35.125C13.4018 37.0124 10.3901 37.0715 8.50266 35.2568ZM32.1726 7.1084L33.9364 8.80418C35.8238 10.6189 35.8829 13.6306 34.0682 15.518L25.3649 24.57L16.7556 16.2922L25.4588 7.24028C27.2736 5.35286 30.2852 5.29368 32.1726 7.1084ZM16.7202 36.5708L35.5719 16.9638C38.1839 14.2472 38.0981 9.9117 35.3822 7.30043L33.6185 5.60465C30.9019 2.99267 26.567 3.0778 23.9551 5.79442L14.8156 15.3C14.688 15.3531 14.569 15.4327 14.467 15.5388C14.3651 15.6448 14.2908 15.7662 14.2428 15.8958L5.10334 25.4014C2.49136 28.118 2.5765 32.4528 5.29312 35.0648L7.05684 36.7605C9.77272 39.3718 14.1082 39.2874 16.7202 36.5708Z",
    fill: "#2E7161"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_230_4093"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41.8848,
    height: 17.3669,
    fill: "white",
    transform: "translate(0 30.1928) rotate(-46.125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreatments);
export default __webpack_public_path__ + "static/media/treatments.1367ea19c8c49a768a74539e3ae69291.svg";
export { ForwardRef as ReactComponent };